import FilterIcon from '../../assets/icons/FilterIcon.svg?react';
import { DEMAND, CASE_TYPE, CASE_TYPE_DEMANDS } from '@demandproai/shared';
import Constants from '../../Constants';
import { useTemplateContext } from '../../pages/template-builder/context/TemplateContext';
import { useProductContext } from '../../contexts/ProductContext';
import useCaseTypeOptions from '../../hooks/useCaseTypeOptions';
import { useSelector } from 'react-redux';
import { getDemandText } from '@demandproai/shared';
import XSelect from '../common/XSelect';


const DemandTypeFilter = () => {
    const { state, caseType, demandType, onChangeState, onChangeCaseType, onChangeDemandType } = useTemplateContext();
    const { CASE_TYPE_DEMANDS_MT, DEFAULT_CASE_TYPE_MT } = useProductContext();
    const { demandNameMap } = useSelector((s) => s.demandMap);

    const caseTypeOptions = useCaseTypeOptions();
    const demands = CASE_TYPE_DEMANDS_MT || CASE_TYPE_DEMANDS;
    const defaultCaseType = DEFAULT_CASE_TYPE_MT || CASE_TYPE.AUTO_ACCIDENT;

    const activeDemands = demands?.[caseType || defaultCaseType]?.filter(
        v => v !== DEMAND.Medical_Chronology
    );

    const demandTypeOptions = activeDemands?.map((v) => ({
        value: v,
        text: getDemandText({ state, caseType, value: v, demandNameMap }),
    })) ?? [];

    const filterWrapperClasses = 'flex-1 min-w-25';

    return (
        <div className="flex flex-wrap items-center mb-4 gap-2">
            <span className="flex items-center gap-1">
                <FilterIcon />
                <span className="text-base text-subtle font-semibold">Filter</span>
            </span>

            <div className={filterWrapperClasses}>
                <XSelect
                    value={caseType}
                    onChange={onChangeCaseType}
                    options={caseTypeOptions}
                    emptyOption="All Case Type"
                />
            </div>

            <div className={filterWrapperClasses}>
                <XSelect
                    value={demandType}
                    onChange={onChangeDemandType}
                    options={demandTypeOptions}
                    emptyOption="All Demand Types"
                />
            </div>

            <div className={filterWrapperClasses}>
                <XSelect
                    value={state}
                    onChange={onChangeState}
                    options={Constants.Dropdowns.States}
                    emptyOption="All States"
                />
            </div>
        </div>
    );
};

export default DemandTypeFilter;
